import doc                          from '@widesk-core/decorators/doc';
import AbstractPartnershipTypeModel from './AbstractPartnershipTypeModel';
import { Translatable }             from '@widesk-core/decorators/translatable';

@doc.urnResource('partnership_type')
@doc.translatable({ label: true })
class PartnershipTypeModel extends AbstractPartnershipTypeModel {}

interface PartnershipTypeModel extends Translatable<{ label: true }> {}

export default PartnershipTypeModel;